import { render, staticRenderFns } from "./KSInfo.vue?vue&type=template&id=196d8791&scoped=true&"
import script from "./KSInfo.vue?vue&type=script&lang=js&"
export * from "./KSInfo.vue?vue&type=script&lang=js&"
import style0 from "./KSInfo.vue?vue&type=style&index=0&id=196d8791&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196d8791",
  null
  
)

export default component.exports